"use client";

import React from "react";
import { Building2, Users, Map, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  title: "Música para Cumpleaños",
  description: "Canciones personalizadas que reflejan la personalidad, los recuerdos y los momentos especiales de cada persona, creando un regalo único e inolvidable.",
  icon: Building2,
  link: "/ServicesPage"
}, {
  title: "Eventos Familiares",
  description: "Producciones musicales personalizadas que acompañan bodas, aniversarios y reuniones familiares con emoción, significado y un toque especial.",
  icon: Users,
  link: "/ServicesPage"
}, {
  title: "Proyectos Corporativos",
  description: "Música original y producciones personalizadas para empresas que desean fortalecer su imagen, comunicar sus valores y conectar mejor con su audiencia.",
  icon: Map,
  link: "/ServicesPage"
}];
export default function Nonreligiousmusicservices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="264621" id="nonreligiousmusicservices" className="bg-background text-foreground py-24 lg:py-32 border-t border-border/10">
      <div className="page-container">
        <div className="mb-16 max-w-2xl">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-4">
            Creatividad Sin Límites
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Producciones musicales personalizadas para cada ocasión especial, diseñadas para inspirar, emocionar y transmitir mensajes con propósito.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {servicesData.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="bg-card/40 border-t-4 border-t-chart-1 border-x-border/40 border-b-border/40 backdrop-blur-md hover:border-chart-1/50 hover:bg-card/60 transition-all duration-300 flex flex-col h-full group shadow-lg rounded-lg">
                <CardHeader>
                  <div className="size-12 rounded-lg bg-chart-1/10 flex items-center justify-center mb-4 group-hover:bg-chart-1/20 transition-colors duration-300 shadow-sm">
                    <Icon className="size-6 text-chart-1" />
                  </div>
                  <CardTitle className="font-default text-xl text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <CardDescription className="text-muted-foreground text-base leading-relaxed font-default">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter>
                  <Button variant="ghost" className="text-chart-1 hover:text-chart-1 hover:bg-chart-1/10 p-0 h-auto font-semibold group/btn" asChild>
                    <Link to={service.link}>
                      Ver detalles 
                      <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}